/*jslint node: true*/
"use strict";

var ko = require("pli/knockout");
var pli = require("pli/forms");
var pliObservable = require("pli/forms-knockoutcontrols");
var picklistBehaviour = require("pli/forms-knockoutcontrols-picklist");

var dataCache = require("../datacache");
var dependentRequiredBehaviour = require("../ko-behaviours-dependentrequired");
var picklistItemExtensions = require("./picklistItemViewModelExtensions");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// PicklistItemViewModel
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function PicklistItemViewModel(form) {
    this.initPicklistItem("Geo-PicklistItem-", form);

    // initialize properties (non-serialized)
    this.extras.categoryData = ko.observable();
    this.extras.hasCategory = ko.observable(false);
    this.extras.typeDisplayName = ko.observable();

    // initialize properties (serialized)
    this.code = this.id = pliObservable(null, null, "required");
    this.description = pliObservable();
    this.category = pliObservable(null, { trigger: this.extras.hasCategory, expectedValue: true, picklistData: this.extras.categoryData }, picklistBehaviour, dependentRequiredBehaviour);
    this.type = ko.observable();

    this.extras.displayName = ko.computed(PicklistItemViewModel.prototype._computeDisplayName, this);
}


//-------------------------------------------
PicklistItemViewModel.prototype.load = function loadPicklistItem(record) {
    record = record || {};

    // clean-up category subscription
    if (this.extras._categorySubscription && this.extras._categorySubscription.dispose) {
        this.extras._categorySubscription.dispose();
        this.extras._categorySubscription = null;
    }

    // initialize category
    if (record.categoryName) {
        var o = dataCache.getObservable(record.categoryName);
        this.extras._categorySubscription = o.subscribe(PicklistItemViewModel.prototype._updateCategory, this);
        this._updateCategory(o());
        this.extras.hasCategory(true);
    } else {
        this.extras.categoryData(null);
        this.extras.hasCategory(false);
    }

    this.code.reset();
    this.description.reset();
    this.category.reset();

    // initialize picklist item data
    this.guid(record.guid || null);
    this.code.load(record.code);
    this.description.load(record.description);
    this.category.load(record.category);
    this.type(record.type || null);
    this.extras.typeDisplayName(record.typeDisplayName || null);
};


//-------------------------------------------
PicklistItemViewModel.prototype._computeDisplayName = function computePicklistItemDisplayName() {
    var id = this.id(), typeDisplayName = this.extras.typeDisplayName();
    return (id ? "".concat(typeDisplayName).concat(" ").concat(id) : "(No code yet)");
};


//-------------------------------------------
PicklistItemViewModel.prototype._updateCategory = function updatePicklistItemCategory(value) {
    this.extras.categoryData(value);
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
var picklistItemForm = pli.forms.registry.picklistItemForm;

if (typeof picklistItemForm !== "object") { throw new Error("Picklist item form element could not be found - did you render it using CreatePicklistItemForm?"); }
if (picklistItemForm.viewModel) { throw new Error("Picklist item form has already been initialized"); }

ko.utils.extend(PicklistItemViewModel.prototype, picklistItemExtensions.mixins);
picklistItemForm.viewModel = new PicklistItemViewModel(picklistItemForm);


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = PicklistItemViewModel;



//////////////////
// WEBPACK FOOTER
// ./app/picklist-common/picklistItemViewModel.js
// module id = 495
// module chunks = 49